import React, { useEffect } from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl } from '../../lib/ep.js';
import { Route, HashRouter as Router, Switch } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import ActionLink from '../builder/ActionLink.js';
import BuilderCanvas from '../builder/BuilderCanvas';
import BuilderMain from '../builder/BuilderMain.js';
import BuilderSidebar from '../builder/BuilderSidebar';
import Input from '../builder/Input';
import MediaUploader from '../builder/MediaUploader.js';
import { AlertMessage } from '../builder/Message.js';
import Model from '../builder/Model';
import { NavigationTabsBuilder } from '../builder/NavigationTabs';
import RichEditor from '../builder/RichEditor';
import Select from '../builder/Select.js';
import Tooltip from '../builder/Tooltip.js';

import Layout from '../front/Layout';

import transferPlaceholder from '../../hoc/transferPlaceholder';

import BuilderSubSectionTitle from './BuilderSubSectionTitle.js';
import PrizeGallery from '../front/loyalty/PrizeGallery.js';

import { loadTokens } from '../../reducers/loyalty_tokens.js';

const InputPlaceHolder = injectIntl(transferPlaceholder(Input));
const RichPlaceHolder = injectIntl(transferPlaceholder(RichEditor));

const StageForm = ({ stage, change, ...props }) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const tokens = props?.tokens ?? [];

	const tag_types = [
		{ k:'simple', v:i18n("Simple") },
		{ k:'tag', v:i18n("Price tag") },
	];

	return (
		<>
			<BuilderSidebar onSave={props.saveStage}>
				<NavigationTabsBuilder
					relative_selection={true}
					active={`${props.nav_active}`}
					sections={props?.nav_sections ?? []}
				>{props.stage_indicator}</NavigationTabsBuilder>

				<article>
					<Model model={stage} change={change}>
						<Select
							name='loyalty_tag_type'
							values={tag_types}
							_class={{ size:60, first:true }}
						>Token type</Select>
					</Model>
				</article>

				<article class="gui_not_in_top_huge">
					<BuilderSubSectionTitle
						title="Contents"
						icon='knk-profile'
					/>

					<Model model={stage} change={change}>
						<MediaUploader
							imageField="direct_image"
							videoField="main_video"
							image={stage.full_direct_image}
							video={(stage.main_video) ? stage.main_video.url : null}
						>Upload media</MediaUploader>

						<RichPlaceHolder
							name="direct_description"
							placeholder="Registering the participation..."
							label_props={{
								tooltip:<Tooltip>Enter a blank space to delete the text</Tooltip>,
							}}
						>Description</RichPlaceHolder>

						<InputPlaceHolder
							placeholder="Continue"
							name="main_button"
							autotranslate={false}
							_class={{ size:40 }}
						>{i18n("Label for '%s' button").replace('%s', i18n("Continue"))}</InputPlaceHolder>
					</Model>
				</article>
			</BuilderSidebar>

			<BuilderCanvas fit_to_window="content">
				<Layout
					promo={props.promotion}
					is_builder={true}
					page="quiz"
					menus={props.promoModel.Custom__Menus}
					layout_extra_classes="is_new_game"
				>
					<div style={{width:'100%'}}>
						{(tokens.length > 0) && (
							<PrizeGallery
								stage={{ Stage:stage }}
								prizes={props.prizes}
								promotion={{ Promotion:props.promotion }}
								//tokens={tokens}	// same as loyalty.tokens
								loyalty={{
									totals:{
										[tokens[0].LoyaltyToken.id]:12,
										[tokens[1].LoyaltyToken.id]:150,
									},
									tokens:{
										[tokens[0].LoyaltyToken.id]:tokens[0],
										[tokens[1].LoyaltyToken.id]:tokens[1],
									},
								}}
								is_builder={true}
							/>
						)}

						{(tokens.length == 0) && (
							<div>
								<AlertMessage>
									<p>{i18n("There are no tokens created yet.")}</p>

									<p>
										<ActionLink
											_href='#loyalty'
										>Go to Loyalty section</ActionLink>
									</p>
								</AlertMessage>
							</div>
						)}
					</div>
				</Layout>
			</BuilderCanvas>
		</>
	)
};

const StagePrizeGalleryBuilder = ({ base_route, ...props }) => {
	const basename = `/stages/${props.stage.id}/prize`;
	const nav_sections = [
		{ label:"Go back", link:`/stages/${props.stage.id}/options`, icon:'knk-go-prev' },
		{ label:"Settings", link:`${basename}/settings`, icon:'knk-settings' },
	];

	const tokens_store = useSelector((state) => state.tokens);
	const dispatch = useDispatch();
	
	// useEffect(() => {
	// 	if(tokens_store !== false) return;
	// 	loadTokens(props.stage.promotion_id,dispatch);
	// }, []);

	return (
		<BuilderMain pm={props.promoModel}>
			<Router basename={basename} hashType="noslash">
				<Switch>
					<Route exact={true} path="/settings">
						<StageForm
							nav_sections={nav_sections}
							nav_active={`/settings`}
							change={props.change}
							intl={props.intl}
							tokens={tokens_store?.tokens}
							promotion={props.promotion}
							promoModel={props.promoModel}
							saveStage={props.saveStage}
							stage={props.stage}
							prizes={props.prizes}
							stage_indicator={props.stage_indicator}
						/>
					</Route>
				</Switch>
			</Router>
		</BuilderMain>
	)
};

export default injectIntl(StagePrizeGalleryBuilder);